// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__28qew","inner":"Form_inner__2pLeP","range":"Form_range__EZEXD","name":"Form_name__eSH9p","actions":"Form_actions__2SDDm"};